import { render, staticRenderFns } from "./VideoDetailsShare.vue?vue&type=template&id=46586c15&"
import script from "./VideoDetailsShare.vue?vue&type=script&lang=js&"
export * from "./VideoDetailsShare.vue?vue&type=script&lang=js&"
import style0 from "./VideoDetailsShare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports